import { FormElement } from 'pages/Forms/types/form';
import { NonTableElements } from 'pages/Forms/types/formElements';
import { ELEMENT_WITH_ANSWER_KEY } from 'pages/Forms/constants';

export const hasNonEmptyAnswer = (answer: unknown): boolean => {
  if (typeof answer === 'string') {
    return answer.trim() !== '';
  }
  if (Array.isArray(answer)) {
    return answer.length > 0;
  }
  if (typeof answer === 'object' && answer !== null) {
    return Object.keys(answer).length > 0;
  }
  return Boolean(answer);
};

export const extractElementIDsWithNonEmptyPrefilledAnswer = (
  elements: FormElement[],
): string[] => {
  const ids: string[] = [];

  elements.forEach((element) => {
    if (element.type === 'table' || element.type === 'advtable') {
      const tableElement = element as {
        contents?: NonTableElements[][];
        id: string;
      };
      tableElement.contents?.forEach((row) => {
        row.forEach((cell) => {
          if (
            cell.id &&
            hasNonEmptyAnswer((cell as { answer?: unknown }).answer)
          ) {
            ids.push(cell.id);
          }
        });
      });
    } else if (ELEMENT_WITH_ANSWER_KEY.includes(element.type)) {
      const { id, answer } = element as { id: string; answer: unknown };
      if (hasNonEmptyAnswer(answer)) {
        ids.push(id);
      }
    }
  });

  return ids;
};
